import { render, staticRenderFns } from "./LdGatedTab.vue?vue&type=template&id=1230db17"
import script from "./LdGatedTab.vue?vue&type=script&lang=js"
export * from "./LdGatedTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports